"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("./utils");

var defaultProps = {
  as: 'svg',
  fill: 'currentColor',
  width: '1em',
  height: '1em'
};

function filterProps(props) {
  var nextProps = {};
  Object.entries(props).forEach(function (_ref) {
    var key = _ref[0],
        value = _ref[1];

    if (typeof value !== 'undefined') {
      nextProps[key] = value;
    }
  });
  return nextProps;
}

var Icon = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _classNames;

  var Component = props.as,
      spin = props.spin,
      pulse = props.pulse,
      flip = props.flip,
      fill = props.fill,
      className = props.className,
      rotate = props.rotate,
      children = props.children,
      viewBox = props.viewBox,
      width = props.width,
      height = props.height,
      style = props.style,
      rest = (0, _objectWithoutPropertiesLoose2["default"])(props, ["as", "spin", "pulse", "flip", "fill", "className", "rotate", "children", "viewBox", "width", "height", "style"]);

  var _useClassNames = (0, _utils.useClassNames)(),
      componentClassName = _useClassNames[0],
      addPrefix = _useClassNames[1];

  var classes = (0, _classnames["default"])(className, componentClassName, (_classNames = {}, _classNames[addPrefix('spin')] = spin, _classNames[addPrefix('pulse')] = pulse, _classNames[addPrefix("flip-" + flip)] = !!flip, _classNames));
  var rotateStyles = {
    msTransform: "rotate(" + rotate + "deg)",
    transform: "rotate(" + rotate + "deg)"
  };
  (0, _utils.useInsertStyles)();
  var svgProps = filterProps({
    width: width,
    height: height,
    fill: fill,
    viewBox: viewBox,
    className: classes,
    style: rotate ? (0, _extends2["default"])({}, rotateStyles, style) : style
  });
  return /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({
    "aria-hidden": true,
    focusable: false,
    ref: ref
  }, svgProps, rest), children);
});

Icon.displayName = 'Icon';
Icon.defaultProps = defaultProps;
Icon.propTypes = {
  spin: _propTypes["default"].bool,
  pulse: _propTypes["default"].bool,
  rotate: _propTypes["default"].number,
  viewBox: _propTypes["default"].string,
  as: _propTypes["default"].oneOfType([_propTypes["default"].elementType, _propTypes["default"].string]),
  flip: _propTypes["default"].oneOf(['horizontal', 'vertical']),
  fill: _propTypes["default"].string
};
var _default = Icon;
exports["default"] = _default;
module.exports = exports.default;